(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme =
				this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		const addBackground = () => {
			if (
				header.classList.contains("color-inverse") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-inverse");
			}
		};

		const removeBackground = () => {
			if (document.body.classList.contains("overflow-hidden-tablet")) {
				return;
			}

			if (
				header.classList.contains("header-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-inverse");
			}
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);
	};

	header();

document.addEventListener("shopify:section:load", header);
document.addEventListener("shopify:section:unload", header);
document.addEventListener("shopify:section:reorder", header);

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.disclosure__link--flag').forEach(function(link) {
    var dataValue = link.getAttribute('data-value');
    var flag = document.createElement('span');
    var styles = window.getComputedStyle(document.querySelector('.disclosure__link--flag[data-value="' + dataValue + '"]'), ':before');
    flag.style.cssText = 'display:inline-block;width:20px;height:15px;vertical-align:middle;margin-right:8px;background-image:url(https://pillovely.pl/cdn/shop/t/14/assets/sprite-country.png);background-position:' + styles.backgroundPosition + ';background-repeat:no-repeat;background-size:auto;';
    link.prepend(flag);
  });

  if (window.innerWidth <= 749) {
    var localization = document.querySelector('.header__localization');
    var headerRight = document.querySelector('.header-top__right');
    if (localization && headerRight) {
      headerRight.appendChild(localization);
    }

    var disclosureList = document.querySelector('.header__localization .disclosure__list');
    if (disclosureList) {
      disclosureList.style.top = '100%';
      disclosureList.style.bottom = 'auto';
    }

    var locBtn = document.querySelector('.header__localization-button');
    if (locBtn) locBtn.style.fontSize = '11px';
  }
});

})();

